function isSessionStorageAvailable() {
    var result;

    try {
        sessionStorage.setItem('test', '1');
        sessionStorage.getItem('test');
        result = true;
    } catch (e) {
        result = false;
    }
    return result;
}

export default isSessionStorageAvailable;

